import { AppState } from 'src';
import { Dispatch, connect } from 'react-redux';
import { VendorPacketEventsComponent, VendorPacketEventsComponentProperties } from './vendor-packet-events.component';
import { getVendorPacketEvents, saveVendorPacketEvent } from 'src/vendor/vendor.actions';
import { ModalProps } from '@common/components';
import { toggleModal } from '@common/components/common.actions';
import { VendorPacketEventViewModel } from '@models/Vendor';

interface VendorPacketEventsProperties {
  vendorId?: number;
}

function mapStateToProps(
  state: AppState,
  ownProps: VendorPacketEventsProperties
): Partial<VendorPacketEventsComponentProperties> {
  return {
    vendorId: ownProps.vendorId || 0,
    packetEvents: state.vendor.packetEvents
  };
}

function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: VendorPacketEventsProperties
): Partial<VendorPacketEventsComponentProperties> {
  return {
    getVendorPacketEvents: (vendorId: number) => {
      dispatch(getVendorPacketEvents(vendorId));
    },
    toggleModal: (modalProps: ModalProps) => {
      dispatch(toggleModal(modalProps));
    },
    saveVendorPacketEvent: (vendorPacketEvent: VendorPacketEventViewModel) => {
      dispatch(saveVendorPacketEvent(vendorPacketEvent)).then(() => {
        dispatch(getVendorPacketEvents(vendorPacketEvent.vendorId));
        dispatch(toggleModal());
      });
    }
  };
}

export const VendorPacketEvents = connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorPacketEventsComponent);



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-packet/vendor-packet-events.container.ts